import { useDispatch } from "react-redux";
import { settingsActions } from "../../store/index.js";
import styled from "styled-components";
import { useEffect } from "react";

const LanguageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  color: var(--secondary-font-color);
  font-size: 1rem;
  font-family: Georgia, serif;

  @media (max-width: 530px) {
    font-size: 0.8rem;
  }
`;

const LanguageButton = styled.button`
  background-color: transparent;
  font-size: 1rem;
  border: none;
  color: var(--secondary-font-color);

  cursor: pointer;
  font-family: Georgia, serif;

  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.2);
    color: var(--primary-font-color);
  }

  @media (max-width: 530px) {
    font-size: 0.8rem;
    padding: 2px;
  }
`;

const LanguageComponent = () => {
  const dispach = useDispatch();

  useEffect(() => {
    const language = localStorage.getItem("languageCode");
    if (!language) {
      localStorage.setItem("languageCode", "ro");
    }
  }, []);

  const changeHandler = (value) => {
    dispach(settingsActions.change(value));
    localStorage.setItem("languageCode", value);
  };

  return (
    <LanguageContainer>
      <LanguageButton onClick={() => changeHandler("ro")}>RO</LanguageButton>|
      <LanguageButton onClick={() => changeHandler("en")}>EN</LanguageButton>
    </LanguageContainer>
  );
};

export default LanguageComponent;
